import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import LGCrud from "../LGCrud";
import { useSnack } from "../../services/SnakbarProvider";
import { handleError } from "../../services/errorHandler";
import { createConfig, deleteConfig, getConfigList, updateConfig } from "../../api/configs/index.ts";
import { useCompany } from "../../contexts/CompanyContext";

export default function CrudConfigs() {
  const [list, setList] = useState([]);
  const { openSnack } = useSnack();
  const { selectedCompany } = useCompany();

  const fetchData = async () => {
    try {
      const res = await getConfigList();
      setList(res.data);
    } catch (e) {
      openSnack(handleError(e), "error");
    }
  };

  const handlePost = async (data) => {
    try {
      const payload = { ...data, companyId: selectedCompany.id }
      if (payload.isNew) {
        delete payload.isNew;
      }
      await createConfig(payload);
      openSnack("Configuración guardada con éxito", "success");
      fetchData();
    } catch (e) {
      openSnack(handleError(e), "error");
    }
  };

  const handleUpdate = async (id, data) => {
    try {
      await updateConfig(id, { ...data, companyId: selectedCompany.id });
      openSnack("Configuración actualizada con éxito", "success");
      fetchData();
    } catch (e) {
      openSnack(handleError(e), "error");
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteConfig(id);
      openSnack("Configuración eliminada con éxito", "success");
      fetchData();
    } catch (e) {
      openSnack(handleError(e), "error");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Box width={"100%"}>
      <LGCrud
        data={list}
        columns={[
          {
            field: "name",
            headerName: "Nombre",
            flex: 0.7,
            editable: true,
          },
          {
            field: "value",
            headerName: "Valor",
            flex: 0.7,
            editable: true,
          },
          {
            field: "configName",
            headerName: "Tipo de configuración",
            flex: 1,
            editable: true,
          },
        ]}
        actionHandlers={{
          create: handlePost,
          update: handleUpdate,
          delete: handleDelete,
          fetchData: getConfigList,
        }}
      />
    </Box>
  );
} 